import axios from 'axios';

const apiUrl = process.env.VUE_APP_API_URL;
const apiKey = process.env.VUE_APP_API_KEY;
const accountId = process.env.VUE_APP_ACCOUNT_ID;

export const SlotsPediatricFriendly = (child, entity_id, year) => {
    const token = localStorage.getItem('authToken');
    return axios.post(apiUrl+"slots/pediatric-friendly", {child, entity_id, year},
        { headers: { Authorization: `Bearer ${token}` }}
    ).then((response) => response).catch(error => console.log(error));
};
export const SlotsByDate = (child, entiti_id, selectedDateFormatted) => {
    const token = localStorage.getItem('authToken');
    return axios.post(apiUrl+"slots/bydate", {child: child, entity_id: entiti_id, date: selectedDateFormatted},
        { headers: { Authorization: `Bearer ${token}` }}
    ).then((response) => response).catch(error => console.log(error));
};

export const registerSlotsPediatricFriendly = (child, entity_id, year) => {
    const token = localStorage.getItem('authToken');
    return axios.post(apiUrl + "slots/pediatric-friendly", {
        child,
        entity_id,
        year
    }, {
        headers: { Authorization: `Bearer ${token}` }
    })
    .then((response) => response)
    .catch((error) => {
        console.error("API Error:", error);
        throw error; 
    });
};

